import StatusTab from './parts/StatusTab'
import { ColorEnum } from '@/constants/color'
import { FC } from 'react'
import { View } from 'react-native'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

export type AccountListStatus = 'open' | 'closed'

interface StatusTabsProps {
    value: AccountListStatus
    counts: Record<AccountListStatus, number>
    onChange: (status: AccountListStatus) => void
}

const StatusTabs: FC<StatusTabsProps> = ({ value, counts, onChange }) => {
    const { styles } = useStyles(stylesheet)

    return (
        <View accessibilityRole="tablist" style={styles.container}>
            <StatusTab
                status="open"
                active={value === 'open'}
                count={counts.open}
                onPress={onChange}
            />
            <StatusTab
                status="closed"
                active={value === 'closed'}
                count={counts.closed}
                onPress={onChange}
            />
        </View>
    )
}

const stylesheet = createStyleSheet({
    container: {
        minHeight: 36,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 4,
        backgroundColor: ColorEnum.WHITE,
    },
})

export default StatusTabs
